import { icons } from "../assets/icons/icons"
import { ContainerShape, HexagonShape } from "./Shape"
import imgHoney from '../assets/honey.png'
import { useToast } from "~/core/contexts/ToastContext"
import { useSound } from "./SoundHandler"
import { WWW } from "~/core/constants"
import { useReferralCode } from "../hooks/useReferral"

export const ReferralCode = () => {
  const { data } = useReferralCode()
  const toast = useToast()
  const sound = useSound()

   const onClick = () => {
    const copyText = `${WWW}/?ref=${data!.referralCode}`;
    navigator.clipboard.writeText(copyText);
    toast.success('Copied to clipboard')
    sound.play('click');
  }

  if (!data)
    return

  return (
    <ContainerShape cornerDiagonal={20} cornerRadius={12} strokeWidth={2}>
      <button onClick={onClick} className="relative flex items-center gap-3 p-4 w-[331px]">
        <HexagonShape cornerRadius={6} strokeWidth={1}>
            <div className='w-10 h-10 p-2'>
            <img src={icons.screenShare} />
            </div>
        </HexagonShape>
      <div className="flex flex-col mr-1 -mb-1">
          <p className="text-left text-[10px] font-blinko text-white/80">
            Referral code:
          </p>
          <div className="flex items-center relative gap-2">
          <p className="text-base font-blinko text-white">
            {data.referralCode}
          </p>
          </div>
      </div>

      <img src={imgHoney} className='absolute right-0 top-0 w-[175px] -mr-4 -mt-2'/>
    </button>
  </ContainerShape>
  )
}
